export class WorkflowBuilderError extends Error {
  constructor(
    public readonly workflowName: string,
    public readonly nodeName: string | null,
    message: string,
  ) {
    super(message);
    this.name = 'WorkflowBuilderError';
  }
}

export class SeedWorkflowsError extends Error {
  constructor(
    public readonly workflowName: string,
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'SeedWorkflowsError';
  }
}
